import React, { Component } from "react";
import { removeRates } from "../../../../libs/functions";

import ManageEditMerchantRates from "./ManageEditMerchantRates";

import Swal from "sweetalert2";
import Util from "../../../../libs/util";

class ManageMerchantGatewayRatesTable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rates: this.parseRates(props.rates[props.currency]),
			paymentTypes: Object.keys(props.MDRTypes),
		};
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.rates) !== JSON.stringify(this.props.rates))
			this.setState({
				rates: this.parseRates(this.props.rates[this.props.currency]),
			});
	}

	parseRates = (rates) => {
		let parsed = {};
		for (let rate of rates) {
			const { type, transactionFee } = rate;
			for (let t of type) {
				parsed[t] = {
					local: transactionFee.local,
					overseas: transactionFee.overseas,
				};
			}
		}
		return parsed;
	};

	openModal = (gateway) => {
		Util.showModal(`manage-edit-rates-${gateway}`);
	};

	deleteRates = () => {
		const { gateway, currency, merchant, retrieveMerchants } = this.props;
		Util.promptConfirmation().then((result) => {
			if (result.value) {
				Swal.fire({
					title: "Removing rates",
					onBeforeOpen: () => {
						Swal.showLoading();
					},
					onOpen: async () => {
						try {
							let status = await removeRates({
								merchantId: merchant.id,
								gateway,
								currency,
							});
							if (status) {
								Swal.fire({
									icon: "success",
									title: "Rates removed",
								}).then(async () => {
									retrieveMerchants(true);
								});
							}
						} catch (err) {
							Swal.fire({
								icon: "error",
								title: `Unable to remove rates`,
								onClose: () => {},
							});
						}
					},
				});
			}
		});
	};

	render() {
		const {
			merchant,
			MDRTypes,
			gateway,
			currency,
			baseRate,
			retrieveMerchants,
			readOnly,
		} = this.props;
		const { rates, paymentTypes } = this.state;

		return (
			<>
				{baseRate[currency] && (
					<ManageEditMerchantRates
						merchant={merchant}
						MDRTypes={MDRTypes}
						gateway={gateway}
						currency={currency}
						rates={rates}
						baseRate={baseRate[currency]}
						retrieveMerchants={retrieveMerchants}
					/>
				)}
				<div>
					<span className="uk-flex uk-flex-middle">
						Transaction Fees
						{!readOnly && (
							<button
								className="uk-margin-left uk-icon-button uk-button-primary"
								uk-icon="icon: fa-solid-pencil-alt; ratio: 0.5"
								type="button"
								onClick={() => {
									this.openModal(gateway);
								}}
							/>
						)}
						{!readOnly && (
							<button
								className="uk-margin-small-left uk-icon-button uk-button-danger"
								uk-icon="icon: fa-solid-trash; ratio: 0.5"
								type="button"
								onClick={this.deleteRates}
							/>
						)}
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</div>
				<div className="view-merchant-rates-table uk-overflow-auto uk-margin-bottom">
					<table className="uk-table uk-table-striped uk-table-middle">
						<thead>
							<tr>
								<th className="uk-width-3-5">Payment Type</th>
								<th className="uk-width-1-5 uk-text-center">Local Card</th>
								<th className="uk-width-1-5 uk-text-center">Overseas Card</th>
							</tr>
						</thead>
						<tbody>
							{paymentTypes.map((type) => {
								let prefix = `${gateway}.${currency}.${type}`;
								let paymentRate = rates[type];
								if (paymentRate) {
									return (
										<tr key={`manage-${prefix}-rate`}>
											<td className="uk-width-3-5">
												<img
													className="uk-img"
													src={`data:image/*;base64,${MDRTypes[type].image}`}
													width="35"
												/>
												<span className="uk-margin-small-left">
													{MDRTypes[type].label}
												</span>
											</td>
											<td className="uk-width-1-5 uk-text-center">
												{paymentRate.local}%
											</td>
											<td className="uk-width-1-5 uk-text-center">
												{paymentRate.overseas}%
											</td>
										</tr>
									);
								}
							})}
						</tbody>
					</table>
				</div>
			</>
		);
	}
}

export default ManageMerchantGatewayRatesTable;
